import { z } from 'zod'

// Trainer API (/api/v1) response shapes. Rails tests pipe real responses
// through tools/contract/check.ts against these.

export const ApiUser = z.object({ id: z.string(), name: z.string(), email: z.string() })
export type ApiUser = z.infer<typeof ApiUser>

/** POST /api/v1/session */
export const SessionResponse = z.object({ token: z.string().min(1), user: ApiUser })
export type SessionResponse = z.infer<typeof SessionResponse>

export const MyProduction = z.object({
  // The production slug — also the manifest's production.id.
  id: z.string(),
  title: z.string(),
  publishedVersion: z.number().int().positive(),
  characterIds: z.array(z.string()),
  understudyCharacterIds: z.array(z.string()),
})
export type MyProduction = z.infer<typeof MyProduction>

/** GET /api/v1/me */
export const Me = z.object({ user: ApiUser, productions: z.array(MyProduction) })
export type Me = z.infer<typeof Me>

/** Error bodies: { error: "unauthorized" | "invalid_credentials" | "not_found" | "rate_limited" } */
export const ApiError = z.object({ error: z.string() })
